<template>
  <div>
    <SelectedProductsTable ref="elSelPT" :list="selected"></SelectedProductsTable>
    <div class="form-group">
      <ButtonSaleType v-model="type_id" @change="modeChangeHandler"></ButtonSaleType>
    </div>
    <!-- v-show="priceChanged" -->
    <ChangePriceJustificationForm v-show="hasJustifyPriceChange" ref="elJustification"></ChangePriceJustificationForm>
    <div v-show="type_id == ENVIO_DELIVERY">
      <div class="form-group">
        <label for="">Nombre *</label>
        <input type="text" class="form-control" v-model="name" list="suggestNameclient" />
        <datalist id="suggestNameclient">
          <option value="SIN NOMBRE"></option>
        </datalist>
        <app-form-errors :member="errors.name"></app-form-errors>
      </div>
      <div class="form-group">
        <label for="">Nro. Teléfono / Celular *</label>
        <input type="number" class="form-control" v-model="phone" step="1" @keyup.enter="searchClientAddresses" />
        <small class="text-muted">
          <span class="badge badge-info"><i class="fas fa-info"></i></span>
          Presiona enter para buscar direcciones</small>
        <app-form-errors :member="errors.phone"></app-form-errors>
      </div>
      <div class="form-group">
        <ClientAddresses ref="elClientAddresses" v-model="address"
          @set-delivery-price="setDeliveryPriceHandler($event)">
        </ClientAddresses>
        <app-form-errors :member="errors.address"></app-form-errors>
      </div>

      <app-checkbox class="mb-3" v-model="setTime">
        Seleccionar hora
      </app-checkbox>

      <div class="form-group" v-show="setTime">
        <label for="">Hora de Entrega</label>
        <SelectNearTime ref="elSelNT" v-model="timeToSend"></SelectNearTime>
      </div>
    </div>

    <div class="form-group">
      <label for="">Nota</label>
      <app-textarea v-model="notes" placeholder="Detalles de la dirección o el pedido"></app-textarea>
      <app-form-errors :member="errors.notes"></app-form-errors>
    </div>

    <div class="form-group">
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon1">Monto Recibido</span>
        </div>
        <input type="number" step="0.00" ref="elInputPay" class="form-control" v-model="pay" @keyup.enter="save"
          @keyup="payChangeHandler" />
      </div>
    </div>

    <div class="form-group">
      <label for="">Vuelto {{ pay_change | money }}</label>
    </div>

    <div class="alert alert-danger" role="alert" v-show="errorMessage.length > 0">
      {{ errorMessage }}
    </div>

    <app-button-submit :disabled="errors" v-show="saleId == 0" @click="save" :loading="sending">
      Registrar venta
    </app-button-submit>

    <a :href="urlToPrint" target="_blank" class="btn btn-light ml-1" v-show="saleId">
      <i class="fas fa-print"></i> Imprimir
    </a>

    <app-modal-basic ref="elModalDone" :dialogCentered="true">
      <div class="text-center">
        Solicitud Realizada
        <br />
        <i class="fa fa-check"></i>
        <br />

        Te llamaremos en un momento
      </div>
    </app-modal-basic>
  </div>
</template>

<script>
import validate from "validate.js";
import {DinnerService} from "./DinnerService";
import SelectedProductsTable from "./SelectProductsTable.vue";
import SelectNearTime from "../components/SelectNearTime.vue";
import moment from "moment";
import ButtonSaleType from "src/components/ButtonSaleType.vue";
import ClientAddresses from "src/components/ClientAddresses.vue";
import ChangePriceJustificationForm from "./ChangePriceJustificationForm.vue";

function formRules(data) {
  let deliveryRules = {};

  if (data.type_id == 3) {
    deliveryRules = {
      name: {
        length: {
          minimum: 1,
          maximum: 150,
          tooShort: "Escribe el nombre del cliente",
          tooLong: "Muy largo"
        }
      },
      phone: {
        length: {
          minimum: 6,
          maximum: 9,
          tooShort: "Escribe un numero valido",
          tooLong: "Muy largo"
        },
        numericality: {
          notValid: "Escribe un numero valido"
        }
      },
      address: {
        length: {
          minimum: 1,
          maximum: 150,
          tooShort: "Escribe la direccion de envio",
          tooLong: "Muy largo"
        }
      }
    };
  }

  return {
    ...deliveryRules,

    notes: {
      length: {
        maximum: 255,
        tooLong: "Muy largo"
      }
    }
  };
}

export default {
  components: {
    // MapControl,
    SelectedProductsTable,
    SelectNearTime,
    ButtonSaleType,
    ClientAddresses,
    ChangePriceJustificationForm
    // SelectClientByPhone
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    ENVIO_DELIVERY: 3,
    DELIVERY_PRODUCT_ID: null,

    name: "",
    phone: "",
    address: "",
    selected: [],
    type_id: 0,
    timeToSend: "",
    notes: "",

    setTime: false,
    meetingPoints: [],
    homePoint: 0,
    saleId: 0,
    pay: 0,
    pay_change: 0,
    errorMessage: "",
    sending: false,
    addresses: [],
    searchingAddresses: false,
    urlToPrint: "",
  }),

  computed: {
    hasJustifyPriceChange() {
      var priceChanged =
        this.selected &&
        this.selected
          .filter((x) => x.id != this.DELIVERY_PRODUCT_ID)
          .filter((x) => x.unit_price != x.original_unit_price).length > 0;
      return (
        this.$store.state.config.dinner.sale.justify_price_changes &&
        priceChanged
      );
    },
    // priceChanged() {
    //   return (
    //     this.selected &&
    //     this.selected.filter((x) => x.unit_price != x.original_unit_price)
    //       .length > 0
    //   );
    // },
    total() {
      return this.selected
        .map((x) => parseFloat(x.quantity) * parseFloat(x.unit_price))
        .reduce((p, c) => p + c, 0);
    },
    errors() {
      let errors = validate(
        this.$data,
        formRules({
          ...this.$data
        }),
        {
          fullMessages: false
        }
      );
      return errors || false;
    },
    linkSale() {
      return `${process.env.VUE_APP_API_URL}print/store/ticket2/${this.saleId}?print=1`;
    }
  },

  watch: {
    //
  },

  mounted() {
    this.DELIVERY_PRODUCT_ID = this.$store.state.config.dinner.sale.delivery_product_id;
  },

  methods: {
    async searchClientAddresses() {
      this.$refs.elClientAddresses.searchByPhone(this.phone);
    },
    reset() {
      this.name = "";
      this.phone = "";
      this.address = "";
      this.type_id = 1;
      this.notes = "";
      this.saleId = 0;
      this.setTime = false;
      this.$refs.elSelNT.reset();
      this.store_id = 1;
      this.pay = "";
      this.pay_change = 0;
      this.errorMessage = "";

      this.$refs.elClientAddresses.reset();
      this.$refs.elJustification.reset();
    },
    prepare(selectedProducts) {
      this.reset();
      this.selected = selectedProducts;
      this.focusPay();
    },
    focusPay() {
      this.$refs.elInputPay.focus();
    },
    async save() {
      try {
        if (this.saleId) {
          this.errorMessage = "la venta ya se ha registrado";
          return;
        }
        this.urlToPrint = "";
        this.sending = true;
        let oRequest = {};
        oRequest.name = this.name;
        oRequest.phone = this.phone;
        oRequest.address = this.address;
        oRequest.type_id = this.type_id;
        oRequest.store_id = 1;
        oRequest.products = this.selected;
        oRequest.pay = parseFloat(this.pay);
        oRequest.pay_change = this.pay_change;
        if (this.hasJustifyPriceChange) {
          if (!this.$refs.elJustification.isValid()) {
            throw new Error("Justifica el cambio de precio");
          }
          oRequest.price_changed = this.$refs.elJustification.$data;
        }
        if (this.type_id != 3) {
          oRequest.anonymous = 1;
        } else {
          let timeToDelivery = this.$refs.elSelNT.getValue();
          oRequest.time_delivery = moment()
            .hour(timeToDelivery.hour)
            .minute(timeToDelivery.minute)
            .format();
        }
        oRequest.observation = this.notes;
        if (this.setTime) {
          oRequest.observation = `enviar a las ${this.timeToSend} - ${this.notes}`;
        }
        var saleId = await DinnerService.makeSaleRequest(oRequest);
        this.errorMessage = "";
        this.saleId = saleId;
        this.$emit("submitted", saleId);
        this.genUrlToPrint();
      } catch (e) {
        if (e.response && e.response.data.code == 1) {
          this.errorMessage = e.response.data.message;
        } else if (e.message) {
          this.errorMessage = e.message;
        } else {
          this.errorMessage = "Algo salio mal, contacta con soporte";
        }
      }
      this.sending = false;
    },
    payChangeHandler() {
      let payChange = parseFloat(this.pay) - this.$refs.elSelPT.getTotal();
      this.pay_change = payChange > 0 ? payChange : 0;
    },
    modeChangeHandler() {
      if (this.type_id == 3) {
        /** comprobar si ya tiene el producto delivery */
        var indexDelivery = this.selected.findIndex(
          (x) => x.id == this.DELIVERY_PRODUCT_ID
        );
        if (indexDelivery == -1) {
          /** agregar producto delivery */
          this.selected.push({
            id: this.DELIVERY_PRODUCT_ID,
            name: "Servicio delivery",
            unit_price: 3,
            quantity: 1
          });
        }
      } else {
        /** remover el producto dedlivery */
        this.selected = this.selected.filter(
          (x) => x.id != this.DELIVERY_PRODUCT_ID
        );
      }
    },
    setDeliveryPriceHandler(price) {
      var indexDelivery = this.selected.findIndex(
        (x) => x.id == this.DELIVERY_PRODUCT_ID
      );
      if (this.type_id == 3 && indexDelivery != -1) {
        var delivery = this.selected[indexDelivery];
        if (delivery.unit_price != price) {
          if (confirm("Poner el precio por delivery de " + price)) {
            delivery.unit_price = price;
          }
        }
      }
    },

    async genUrlToPrint() {
      if (this.saleId) {
        console.log("config value ", this.$store.state.config.dinner.sale.print_use_action || false );
        if (this.$store.state.config.dinner.sale.print_use_action) {
          this.urlToPrint = "printsctk://" + this.saleId;
        } else {
          this.urlToPrint = process.env.VUE_APP_API_URL +
            this.$store.state.config.dinner.sale.print_route +
            `${this.saleId}?print=1`;
        }
      }
    },
  }
};
</script>

<style scoped></style>
